import React, { useState, useEffect } from "react";
import { Slider } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/system";

import { palette } from "../../styles/palette";
import {
  defaultOverlayDataSelector,
  overlayTimeBandSelector,
  volumeOverlayDateSelector,
} from "../../reducers/app/selector";
import { setOverlayTimeBand } from "../../reducers/app";
import { checkFirstTimeBand, setUpTimeBands } from "../../utils/map/timeBands";
import {
  FULL_DAY,
  BUTTON_NUMBERS,
  FIRST_TIMEBAND,
  DEFAULT_TIMERANGE,
} from "../../constants/timeBands";
import "./TimeBandSlider.css";


const StyledSlider = styled(Slider)({
  '& .MuiSlider-markLabel': {
    color: palette.lightGrey,
  },
 '& .MuiSlider-mark': {
  color: palette.dpdRed,
  height: 6,
 },
 '& .MuiSlider-rail': {
  color: palette.typography.white.solid,
  height: 6,
 },
 '& .MuiSlider-track': {
  color: palette.dpdRed,
  height: 6,
 },
 '& .MuiSlider-thumb': {
  color: palette.dpdRed,
  border: palette.typography.black.solid,
  top: "55%",
 }
});

export const TimeBandSlider = () => {
  const dispatch = useDispatch();
  const [isFullRouteOn, setIsFullRouteOn] = useState(false);
  const [showLabelDisplay, setShowLabelDisplay] = useState(false);
  const volumeDate = useSelector(volumeOverlayDateSelector);
  const overlayTimeBand = useSelector(overlayTimeBandSelector);
  const defaultOverlayData = useSelector(defaultOverlayDataSelector);
  const [selectedBand, setSelectedBand] = useState(overlayTimeBand);
  const [selectedTimeRange, setSelectedTimeRange] = useState(DEFAULT_TIMERANGE);
  const [sliderValue, setSliderValue] = useState(16);

  useEffect(() => {
    if (showLabelDisplay) setTimeout(() => setShowLabelDisplay(false), 5000);
    // Fixes issue of the slider label will not disappear if you let go of the mouse while the cursor is off the component
  }, [showLabelDisplay]);

  useEffect(() => {
    setIsFullRouteOn(false);
    setSelectedBand(overlayTimeBand);
    setSliderValue(16);
    // Reset timeband on date change
    // eslint-disable-next-line
  }, [defaultOverlayData]);

  let firstBand = checkFirstTimeBand(
    FIRST_TIMEBAND,
    defaultOverlayData,
    volumeDate
  );

  const timeBands = setUpTimeBands(firstBand, selectedTimeRange);
  const maxValue = timeBands.length - 1;

  const sliderValues = timeBands.map((timeBand, index) => ({
    value: index,
    label: timeBand.endsWith("00") || firstBand === timeBand ? timeBand : null,
    timeBand,
  }));

  const onSliderChange = (value) => {
    setShowLabelDisplay(true);
    setSliderValue(value);
    const newTimeBand = sliderValues.find(
      (sliderValue) => sliderValue.value === value
    ).timeBand;
    if (newTimeBand !== overlayTimeBand) {
      dispatch(setOverlayTimeBand(`${newTimeBand}:00`));
      setSelectedBand(`${newTimeBand}:00`);
    }
  };

  const onFullRouteToggle = () => {
    setShowLabelDisplay(false);
    setIsFullRouteOn(!isFullRouteOn);
    if (isFullRouteOn) {
      dispatch(setOverlayTimeBand(selectedBand));
    } else {
      dispatch(setOverlayTimeBand(null));
    }
  };

  const onTimeRangeSelection = (buttonNumber) => {
    if (buttonNumber < parseInt(selectedBand.substring(0, 2))) {
      const maxTimeBand =
        buttonNumber < 10 ? `0${buttonNumber}:00` : `${buttonNumber}:00`;
      const newSliderValue = sliderValues.find(
        (sliderValue) => sliderValue.timeBand === maxTimeBand
      ).value;
      setSliderValue(newSliderValue);
      dispatch(setOverlayTimeBand(`${maxTimeBand}:00`));
      setSelectedBand(`${maxTimeBand}:00`);
    }
    setSelectedTimeRange(parseInt(buttonNumber));
  };

  return (
    <div className="sliderContainer">
      <div className="slider">
        {isFullRouteOn && <div className="sliderDisabledCover" />}
        <StyledSlider
          key={`slider-${volumeDate}`} // Rerenders Slider on datePicker change so the Slider resets back to default value
          marks={sliderValues}
          steps={timeBands.length}
          max={maxValue}
          defaultValue={0}
          value={sliderValue}
          valueLabelDisplay={!showLabelDisplay ? "off" : "on"}
          valueLabelFormat={(value) => timeBands[value]}
          onMouseUp={() => setShowLabelDisplay(false)}
          onChange={(e, value) => onSliderChange(value)}
        />
      </div>
      <div>
        <label className="sliderCheckboxContainer">
          {FULL_DAY}
          <input
            className="sliderCheckbox"
            type="checkbox"
            value="full"
            checked={!!isFullRouteOn}
            onChange={onFullRouteToggle}
          />
        </label>
      </div>
      <div className="sliderButtonContainer">
        {BUTTON_NUMBERS.map((button_number) => {
          const buttonNumber = parseInt(button_number);
          return (
            <button
              key={button_number}
              className={`sliderButton ${
                buttonNumber === selectedTimeRange ? "sliderButtonActive" : ""
              }`}
              onClick={() => onTimeRangeSelection(buttonNumber)}
              value={buttonNumber}
            >
              {buttonNumber}h
            </button>
          );
        })}
      </div>
    </div>
  );
};
